import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/app.css'
import { installChunkRecovery } from '../lib/chunkRecovery'

installChunkRecovery()

const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, { default: React.ComponentType }>

createInertiaApp({
  id: 'app',
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Missing Inertia page component: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(<App {...props} />)
    }
  },
})
